/**
 * isBindable returns true if the expression passed could be used as a safe left hand side of an assignment
 */
export function isBindable(expression: string) {
  if (expression.match(/^(true|false|null|undefined|\d+([.]\d+)?)$/)) {
    return false
  }

  const segmentRE = /^((?:[_a-z][_a-z0-9]*[.])*[_a-z][_a-z0-9]*)/i

  let first = true
  let startExpression = expression
  do {
    if (expression[0] === '[') {
      if (first) return false

      const arrResult = consumeArrayBrackets(expression)
      if (arrResult === false) return false
      expression = arrResult
    } else if (expression[0] === '.' && !first) {
      expression = expression.substring(1)
    } else {
      const match = segmentRE.exec(expression)
      if (match) {
        expression = expression.substring(match[0].length)
      } else if (first) {
        return false
      }
    }
    first = false
    if (expression === startExpression) {
      return false
    }
    startExpression = expression
  } while (expression.length !== 0)

  return true
}

function consumeArrayBrackets(expression: string): string | false {
  let pos = 1
  let nesting = 1
  while (pos < expression.length) {
    switch (expression[pos]) {
      case '[':
        nesting++
        break
      case ']':
        nesting--
        if (nesting === 0) {
          const arraySegment = expression.substring(1, pos)
          return (arraySegment.match(/^\d+$/) || isBindable(arraySegment)) && expression.substring(pos + 1)
        }
        break
    }
    pos++
  }

  return false
}
